import API from '@/views/Fdc/Apis/'

/**
 * Parameter Save Modal Component
 * Parameter 정보를 저장하는 component
 */
export default {
  name: 'parameterAddModal',
  /**
   * Vid Type 배열
   * @param {Array} vidTypeItems
   *
   * Parameter Value Type 배열
   * @param {Array} paramValTypeItems
   *
   * Offset Type 배열
   * @param {Array} offsetTypeItems
   *
   * Parameter Level 배열
   * @param {Array} paramLevelItems
   *
   * Modal 표시 여부
   * @param {Boolean} visible
   *
   * Modal 초기 data
   * @param {Object} initValue
   *
   * Save Method 실행 여부
   * @param {Boolean} saveReady
   *
   * Save 종료 시 실행 method
   * @param {Function} saveComplete
   *
   * Save 취소 시 실행 method
   * @param {Function} cancelSave
  */
  props: [
    'vidTypeItems',
    'paramValTypeItems',
    'offsetTypeItems',
    'paramLevelItems',
    'visible',
    'initValue',
    'saveReady',
    'saveComplete',
    'cancelSave',
    'parameterRowData'
  ],
  watch: {
    /**
     * Modal 표시 여부 감지
     * 초기 data를 설정합니다.
     */
    visible: {
      handler () {
        this.initData()
      }
    },
    /**
     * saveReady 변화 감지
     * @param {Boolean} value 저장 실행 여부
     * saveReady가 true일 때 saveData method를 실행합니다.
     */
    saveReady (value) {
      if (value) {
        this.saveData()
      }
    }
  },
  beforeMount () {
    this.initData()
  },
  methods: {
    /**
     * 초기 Data 설정
     */
    initData () {
      this.fab = this.initValue.fab
      this.eqpId = this.initValue.eqpId
      this.moduleId = this.initValue.moduleId
      this.vidTypeList = this.vidTypeItems
      this.paramValTypeList = this.paramValTypeItems
      this.offsetTypeList = this.offsetTypeItems
      this.paramLevelList = this.paramLevelItems

      if (this.initValue.saveType === 'Edit') {
        this.paramName = this.initValue.paramName
        this.vid = this.initValue.vid
        this.vidType = this.initValue.vidType
        this.paramValType = this.initValue.paramValType
        this.aliasName = this.initValue.aliasName
        this.paramDesc = this.initValue.paramDesc
        this.valueUnit = this.initValue.valueUnit
        this.useYn = this.initValue.useYn
        this.numberYn = this.initValue.numberYn
        this.virtualYn = this.initValue.virtualYn
        this.virtualButton = this.initValue.virtualButton
        this.listYn = this.initValue.listYn
        this.listPosition = this.initValue.listPosition
        this.listDelimiter = this.initValue.listDelimiter
        this.offsetType = this.initValue.offsetType
        this.offsetValue = this.initValue.offsetValue
        this.virtualUsable = this.virtualYn === 'Y'
        this.tempCount = this.initValue.tempCount
        this.paramLevel = this.initValue.paramLevel
      }
    },
    /**
     * Data 초기화
     */
    resetData () {
      if (this.initValue.saveType === 'Add') {
        this.fab = null
        this.eqpId = null
        this.moduleId = null
        this.paramName = 'NA'
        this.vid = null
        this.vidType = 'SVID'
        this.paramValType = 'NONE'
        this.aliasName = 'NA'
        this.paramDesc = null
        this.valueUnit = null
        this.useYn = 'Y'
        this.numberYn = 'Y'
        this.virtualYn = 'N'
        this.virtualButton = null
        this.listYn = 'N'
        this.listPosition = 0
        this.listDelimiter = null
        this.offsetType = null
        this.offsetValue = 0
        this.tempCount = 0
        this.virtualUsable = null
      } else if (this.initValue.saveType === 'Edit') {
        this.fab = null
        this.eqpId = null
        this.moduleId = null
        this.paramName = null
        this.vid = null
        this.vidType = null
        this.paramValType = null
        this.aliasName = null
        this.paramDesc = null
        this.valueUnit = null
        this.useYn = null
        this.numberYn = null
        this.virtualYn = null
        this.virtualButton = null
        this.listYn = null
        this.listPosition = null
        this.listDelimiter = null
        this.offsetType = null
        this.offsetValue = null
        this.tempCount = null
        this.virtualUsable = null
      }
    },
    /**
     * Virtual Parameter 화면 연동
     * @param {Object} item Parameter Object
     * 현재 Virtual Parameter의 Virtual Data(Javascript Function)를 정의할 수 있는 창으로 이동합니다.
     */
    editVirtual (item) {
      let routeData = this.$router.resolve(
        {
          name: 'virtual-parameter',
          query: {
            fab: item.fab,
            eqpId: item.eqpId,
            moduleId: item.moduleId,
            paramName: item.paramName
          }
        }
      )
      window.open(routeData.href, '_blank')
      this.parameterManagerGrid.invalidate()
    },
    /**
     * Virtual Data Edit button click method
     */
    openVirtualDataSettingModal () {
      this.editVirtual(this.initValue)
    },
    /**
     * Parameter 저장
     */
    async saveData () {
      let self = this

      const saveData = {
        fab: this.fab,
        eqpId: this.eqpId,
        moduleId: this.moduleId,
        paramName: this.paramName,
        vid: this.vid,
        vidType: this.vidType,
        paramValType: this.paramValType,
        aliasName: this.aliasName,
        paramDesc: this.paramDesc,
        valueUnit: this.valueUnit,
        useYn: this.useYn,
        numberYn: this.numberYn,
        virtualYn: this.virtualYn,
        listYn: this.listYn,
        listPosition: this.listPosition,
        listDelimiter: this.listDelimiter,
        offsetType: this.offsetType,
        offsetValue: this.offsetValue,
        tempCount: this.tempCount,
        paramLevel: this.paramLevel
      }

      let mustSaveRows = [saveData]

      if (!this.saveValidation(mustSaveRows)) {
        this.cancelSave()
        return
      }

      const message = this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')

      this.$dialog.confirm({
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function saveLastProcess (response) {
            if (response != null && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))
              self.resetData()
              self.saveComplete()
            } else {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'))
            }
          }

          if (mustSaveRows.length > 0) {
            API.BaseInfo.addEqpParam(mustSaveRows).then(result => {
              saveLastProcess(result)
            })
          }
        },
        onCancel: function () {
          self.cancelSave()
        }
      })
    },
    /**
     * Parameter Save Validation
     * @param {Array} rows save data 배열
     * @returns {Boolean} validation 성공 여부
     */
    saveValidation (rows) {
      for (let i in rows) {
        if (!rows[i].eqpId || rows[i].eqpId.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Eqp ID']))
          return false
        } else if (!rows[i].moduleId || rows[i].moduleId.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Module ID']))
          return false
        } else if (!rows[i].vid || rows[i].vid.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Vid']))
          return false
        } else if (!rows[i].vidType || rows[i].vidType.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Vid Type']))
          return false
        } else if (!rows[i].paramValType || rows[i].paramValType.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Param Value Type']))
          return false
        } else if (!rows[i].paramName || rows[i].paramName.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Parameter Name']))
          return false
        } else if (!rows[i].aliasName || rows[i].aliasName.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Alias Name']))
          return false
        } else if (!rows[i].useYn || rows[i].useYn.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Use YN']))
          return false
        } else if (!rows[i].numberYn || rows[i].numberYn.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Number YN']))
          return false
        } else if (!rows[i].virtualYn || rows[i].virtualYn.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Virtual YN']))
          return false
        } else if (!rows[i].listYn || rows[i].listYn.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['List YN']))
          return false
        } else if (rows[i].listPosition === '' || rows[i].listPosition === undefined) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['List Position']))
          return false
        }

        if (this.initValue.saveType !== 'Edit') {
          const existedParamNameList = this.parameterRowData.map(param => param.paramName)
          const isParamNameExist = existedParamNameList.indexOf(rows[i].paramName.trim())

          if (isParamNameExist > -1) {
            this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['Parameter Name']))
            return false
          }
        }

        let isNotVidType = true
        for (let j in this.vidTypeList) {
          if (rows[i].vidType === this.vidTypeList[j]) {
            isNotVidType = false
          }
        }
        if (isNotVidType) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['VID Type']))
          return false
        }
        let isNotParamValType = true
        for (let j in this.paramValTypeList) {
          if (rows[i].paramValType === this.paramValTypeList[j]) {
            isNotParamValType = false
          }
        }
        if (isNotParamValType) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Param Value Type']))
          return false
        }
        let isNotOffsetType = true
        for (let j in this.offsetTypeList) {
          if (!rows[i].offsetType) {
            isNotOffsetType = false
          } else {
            if (rows[i].offsetType === this.offsetTypeList[j]) {
              isNotOffsetType = false
            }
          }
        }
        if (isNotOffsetType) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Offset Type']))
          return false
        }
        if (rows[i].useYn !== 'Y' && rows[i].useYn !== 'N') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Use YN']))
          return false
        }
        let isNotNumberYn = true
        for (let j in this.numberTypeList) {
          if (rows[i].numberYn === this.numberTypeList[j].numberType) {
            isNotNumberYn = false
          }
        }
        if (isNotNumberYn) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Number YN']))
          return false
        }
        let isNotVirtualYn = true
        for (let j in this.virtualList) {
          if (rows[i].virtualYn === this.virtualList[j].virtual) {
            isNotVirtualYn = false
          }
        }
        if (isNotVirtualYn) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Virtual YN']))
          return false
        }
        let isNotListYn = true
        for (let j in this.listTypeList) {
          if (rows[i].listYn === this.listTypeList[j].listType) {
            isNotListYn = false
          }
        }
        if (isNotListYn) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['List YN']))
          return false
        }
        let isNotParamLevel = true
        for (let j in this.paramLevelList) {
          if (rows[i].paramLevel === this.paramLevelList[j]) {
            isNotParamLevel = false
          }
        }
        if (isNotParamLevel) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Param Level']))
          return false
        }
      }
      return true
    }
    // changeParamName () {
    //   this.aliasName = this.paramName
    // }
  },
  data () {
    return {
      fab: null, // Fab data
      eqpId: null, // EQP ID data
      moduleId: null, // Module ID data
      paramName: 'NA', // Parameter Name data
      vid: null, // Vid data
      vidType: 'SVID', // Vid Type data
      paramValType: 'NONE', // Parameter Value Type data
      aliasName: 'NA', // Alias Name data
      paramDesc: null, // Parameter
      valueUnit: null, // Value Unit data
      useYn: 'Y', // Use YN data
      numberYn: 'Y', // Number YN data
      virtualYn: 'N', // Virtual YN data
      virtualButton: null, // Virtual button data
      listYn: 'N', // List YN data
      listPosition: 0, // List Position data - Number
      listDelimiter: null, // List Delimiter data
      offsetType: null, // Offset Type data
      offsetValue: 0, // Offset Value data - Number
      tempCount: 0, // Temp Count data - Number
      paramLevel: null, // Parameter Level data
      vidTypeList: [], // Vid Type combobox 배열
      paramValTypeList: [], // Parameter Value Type combobox 배열
      numberTypeList: [
        { numberType: 'Y' },
        { numberType: 'N' }
      ], // Number YN combobox 배열
      virtualList: [
        { virtual: 'Y' },
        { virtual: 'N' }
      ], // Virtual YN combobox 배열
      listTypeList: [
        { listType: 'Y' },
        { listType: 'N' }
      ], // List Type combobox 배열
      offsetTypeList: [], // Offset Type combobox 배열
      paramLevelList: [], // Parameter Level combobox 배열
      virtualUsable: null // Virtual YN 여부에 따른 button 표시 여부
    }
  }
}
